/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { useEffect } from 'react';

import { STAGES } from './stages';

export default function useSelectClusterOnStageChange(
  selectedStage,
  clusters,
  setSelectedCluster,
  defaultDevClusterId,
  defaultTestClusterId,
  defaultStageClusterId,
  defaultProdClusterId
) {
  useEffect(() => {
    if (selectedStage) {
      let selectedClusterId;
      switch (selectedStage) {
        case STAGES.DEVELOPMENT:
          selectedClusterId = defaultDevClusterId;
          break;
        case STAGES.TESTING:
          selectedClusterId = defaultTestClusterId;
          break;
        case STAGES.STAGING:
          selectedClusterId = defaultStageClusterId;
          break;
        case STAGES.PRODUCTION:
          selectedClusterId = defaultProdClusterId;
          break;
        default:
          selectedClusterId = null;
      }

      const selectedCluster = clusters.find((cluster) => cluster.id === selectedClusterId);
      if (selectedCluster) {
        setSelectedCluster(selectedCluster);
      }
    } else {
      setSelectedCluster(null);
    }
  }, [selectedStage]);
}
